import { handleActions } from 'redux-actions';

import * as actions from 'actions/contributions';

const initialState = {
  loading: false,
  error: null,
  upcomingCreatedWithType: [],
};

const upcomingCreatedWithType = handleActions(
  new Map([
    [
      actions.fetchUpcomingCreatedWithTypeActions.request,
      state => ({
        ...state,
        error: null,
        loading: true,
        upcomingCreatedWithType: null,
      }),
    ],
    [
      actions.fetchUpcomingCreatedWithTypeActions.success,
      (state, action) => ({
        ...state,
        loading: false,
        error: null,
        upcomingCreatedWithType: action.payload,
      }),
    ],
    [
      actions.fetchUpcomingCreatedWithTypeActions.error,
      (state, action) => ({
        ...state,
        loading: false,
        error: action.payload,
        upcomingCreatedWithType: [],
      }),
    ],
  ]),
  initialState,
);

export default upcomingCreatedWithType;
